//Add class to body when resize
(function() {

    //Use Debouncing for performance
    var wpkTimeout;

    window.addEventListener('resize', function() {
        
        var body = document.body;
        body.classList.add('wpk-resize');

        if ( !wpkTimeout ) {
            wpkTimeout = setTimeout(function() {

                body.classList.remove('wpk-resize');
    
                // Reset timeout
                wpkTimeout = null;

    
            }, 500);
        }
    }, false);
})();